var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-card-loader"},[(_vm.loading)?_c('div',[_c('a-skeleton',{attrs:{"active":""}})],1):_c('div',[_c('a-empty')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }